import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "btns-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PepIcon = _resolveComponent("PepIcon")!
  const _component_ShadowBlock = _resolveComponent("ShadowBlock")!
  const _component_KepIcon = _resolveComponent("KepIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Тип подписи", -1)),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_ShadowBlock, {
        class: _normalizeClass(["clickable", { checked: _ctx.modelValue === 'пэп' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectType('пэп')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PepIcon),
          _cache[2] || (_cache[2] = _createTextVNode(" ПЭП "))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ShadowBlock, {
        class: _normalizeClass(["clickable", { checked: _ctx.modelValue === 'кэп' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectType('кэп')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_KepIcon),
          _cache[3] || (_cache[3] = _createTextVNode(" КЭП "))
        ]),
        _: 1
      }, 8, ["class"])
    ])
  ], 64))
}